export default function toggleArrayValue(array, value) {
  if (array.indexOf(value) === -1) {
    return [...array, value];
  }

  return array.filter((el) => el !== value);
}
